/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PaymentServiceProviderDetailsR = t.interface({
  business_name: t.string,

  enabled: t.boolean,

  psp_code: t.string
});

// optional attributes
const PaymentServiceProviderDetailsO = t.partial({
  abi: t.string,

  agid_psp: t.boolean,

  bic: t.string,

  my_bank_code: t.string,

  stamp: t.boolean,

  tax_code: t.string,

  vat_number: t.string
});

export const PaymentServiceProviderDetails = t.intersection(
  [PaymentServiceProviderDetailsR, PaymentServiceProviderDetailsO],
  "PaymentServiceProviderDetails"
);

export type PaymentServiceProviderDetails = t.TypeOf<
  typeof PaymentServiceProviderDetails
>;
